module.exports = __webpack_public_path__ + "img/8.a3037e2e.jpg";